import { render, staticRenderFns } from "./InfoCurso.vue?vue&type=template&id=7987d0d8&scoped=true"
import script from "./InfoCurso.vue?vue&type=script&lang=js"
export * from "./InfoCurso.vue?vue&type=script&lang=js"
import style0 from "./InfoCurso.vue?vue&type=style&index=0&id=7987d0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987d0d8",
  null
  
)

export default component.exports